import { checkout } from './checkout.i18n';
import { payment } from './payment.i18n';

export const en = {
  checkout,
  payment,
};
